/**
 * Shared AI-provider helpers — used by both the admin gateway settings page
 * (pages/gateway/sections/network/ai-settings.js) and the per-connection
 * model picker (components/GatewayAIModelSettings.js).
 */

export const MANAGED_PROVIDER_LABEL = "Control Seat AI — Managed";

export const isProviderReady = (provider) => provider?.ready === true;

export const isManagedProvider = (provider) => (
  provider?.provider_kind === "controlseat_managed"
);

export const providerLabel = (provider) => (
  isManagedProvider(provider) ? MANAGED_PROVIDER_LABEL : provider?.name
);
